import { firestoreDateParser } from '@pedix-workspace/utils';
import { InventoryCount } from './stock.types';
import { withNestedConverter } from '@pedix-workspace/shared-models';

export const getInventoryCountConverter = withNestedConverter<InventoryCount>({
  fromFirestore(snapshot) {
    const inventoryCount = <InventoryCount>snapshot.data();

    return <InventoryCount>{
      ...inventoryCount,
      id: snapshot.id,
      created: firestoreDateParser(inventoryCount.created),
      updated: firestoreDateParser(inventoryCount.updated),
      details: {
        ...inventoryCount.details,
        closedAt: firestoreDateParser(inventoryCount.details.closedAt),
        appliedAt: firestoreDateParser(inventoryCount.details.appliedAt),
      },
    };
  },
  toFirestore(inventoryCount: InventoryCount): InventoryCount {
    return inventoryCount;
  },
});
